import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Users, Building2, Home, LogOut, Calendar } from 'lucide-react';

const AdminNavbar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/admin" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <Home className="h-5 w-5 text-white" />
              </div>
              <span className="text-xl font-bold text-gray-900">Admin Panel</span>
            </Link>

            <div className="hidden md:flex items-center space-x-1">
              <Link to="/admin/doctors">
                <Button
                  variant={isActive('/admin/doctors') ? "default" : "ghost"}
                  className="flex items-center space-x-2"
                >
                  <Users className="h-4 w-4" />
                  <span>Doctors</span>
                </Button>
              </Link>

              <Link to="/admin/clinics">
                <Button
                  variant={isActive('/admin/clinics') ? "default" : "ghost"}
                  className="flex items-center space-x-2"
                >
                  <Building2 className="h-4 w-4" />
                  <span>Clinics</span>
                </Button>
              </Link>

              <Link to="/admin/bookings">
                <Button
                  variant={isActive('/admin/bookings') ? "default" : "ghost"}
                  className="flex items-center space-x-2"
                >
                  <Calendar className="h-4 w-4" />
                  <span>Bookings</span>
                </Button>
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <Link to="/">
              <Button variant="outline" size="sm">
                <LogOut className="h-4 w-4 mr-2" />
                Back to Site
              </Button>
            </Link>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden py-4 border-t border-gray-200">
          <div className="flex flex-col space-y-2">
            <Link to="/admin/doctors">
              <Button
                variant={isActive('/admin/doctors') ? "default" : "ghost"}
                className="w-full justify-start"
              >
                <Users className="h-4 w-4 mr-2" />
                Doctors
              </Button>
            </Link>

            <Link to="/admin/clinics">
              <Button
                variant={isActive('/admin/clinics') ? "default" : "ghost"}
                className="w-full justify-start"
              >
                <Building2 className="h-4 w-4 mr-2" />
                Clinics
              </Button>
            </Link>

            <Link to="/admin/bookings">
              <Button
                variant={isActive('/admin/bookings') ? "default" : "ghost"}
                className="w-full justify-start"
              >
                <Calendar className="h-4 w-4 mr-2" />
                Bookings
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
